import service from "service"

const base_url = process.env.REACT_APP_BASE_URL_API
class Api {
  async category() {
    const res = await service.get(`${base_url}/list/category`)
    const data = res.data.data

    return data.map(val => {
      return {
        id: val.id,
        name: val.name,
        waiver_variant: JSON.parse(val.waiver_variant ?? '[]')
      }
    })
  }

  async booking(code) {
    const res = await service.get(`${base_url}/booking/walk-in/${code}`)
    return res.data.data
  }
}

export default new Api()